import { render } from "./ExtDocBrowser.vue?vue&type=template&id=d0d6a8cc"
import script from "./ExtDocBrowser.vue?vue&type=script&lang=js"
export * from "./ExtDocBrowser.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/ExtDoc/ExtDocBrowser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d0d6a8cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d0d6a8cc', __exports__)) {
    console.log('reload')
    api.reload('d0d6a8cc', __exports__)
  }
  
  module.hot.accept("./ExtDocBrowser.vue?vue&type=template&id=d0d6a8cc", () => {
    console.log('re-render')
    api.rerender('d0d6a8cc', render)
  })

}


export default __exports__